import { SVGProps } from "react";
import { Status } from "@chakra-ui/react";

import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from "../../assets/alert";

export const StatusIcon = ({
  status = "info",
  ...props
}: SVGProps<SVGSVGElement> & { status: Omit<Status, "default"> }) => {
  switch (status) {
    case "success":
      return <SuccessIcon {...props} />;
    case "warning":
      return <WarningIcon {...props} />;
    case "error":
      return <ErrorIcon {...props} />;
    default:
      return <InfoIcon {...props} />;
  }
};
